module.exports = __webpack_public_path__ + "static/img/tb1.7e836192.png";